import { Url } from '@/components/types';
import { AppConfig } from '@/utils/AppConfig';

export const buildSocialShareLink = (
  socialLink: string,
  pathname: string,
  title: string,
  summary: string,
) => {
  const url = new URL(socialLink);
  const domainUrl = url.origin;
  const shareableUrl = `${AppConfig.websiteBasePublicUrl}${pathname}`;

  if (domainUrl.includes('linkedin')) {
    return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(shareableUrl)}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(summary)}&source=${encodeURIComponent(shareableUrl)}`;
  } else if (domainUrl.includes('x.com')) {
    return `https://x.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(shareableUrl)}`;
  } else if (domainUrl.includes('facebook')) {
    return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareableUrl)}`;
  }

  return '';
};

export const buildBreadcrumbLinks = (urls: Array<Url>) => {
  urls = urls.reverse();
  urls.forEach((url, index) => {
    if (index >= 1) {
      const parent = urls[index - 1];
      if (parent.hasTab) {
        url.url = `${parent.url}#${url.url.slice(1)}`;
      }
    }
  });
  return urls;
};
